import { Component, Input, OnInit } from '@angular/core';
import { AppSelectOption } from './app-select-option.interface';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './app-select.component.html',
  styleUrls: ['./app-select.component.scss'],
})
export class AppSelectComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() appSelectOptions: AppSelectOption[];
  @Input() horizontalLabel = false;
  @Input() searchable = false;
  @Input() clearable = false;
  @Input() appSelectFormControl: FormControl = new FormControl();

  constructor() {}

  ngOnInit() {
    if (!this.placeholder) {
      this.placeholder = this.label;
    }
  }
}
